import { useMap } from '@vis.gl/react-google-maps'
import { useEffect } from 'react'

interface IPolylineProps {
  path: google.maps.LatLngLiteral[]
  options?: google.maps.PolylineOptions
}

export const Polyline = ({ path, options }: IPolylineProps): null => {
  const mapInstance = useMap()

  useEffect(() => {
    if (!mapInstance) return

    const polylineInstance = new google.maps.Polyline({
      path,
      map: mapInstance,
      ...options
    })

    return () => {
      polylineInstance.setMap(null)
    }
  }, [mapInstance, path, options])

  return null
}
